/* eslint-disable no-use-before-define */
import React from 'react'
import { getId, } from '../../twd/twd'

export const Settlement = ({settlement, setSettlement, err, onEnter}) => {
    const id = getId()
    return <React.Fragment>
        <div className='vertical-offset-sm'>
        <label
            className="label"
            htmlFor={id}
            style={{ lineHeight:'20px', display:'inline', marginBottom:0}}
        >Settlement date</label>

        <div className={err ? ' has-error' : ''}>
        <div className='vertical-offset-xxs'>
            <input
                className="form-control text-muted"
                type="text"
                id={id}
                value={settlement}
                onChange={(e) => setSettlement(e.target.value)}
                onKeyUp={(e) => {
                    let key = e.keyCode || e.key || e.which
                    if (!(key===13 || key === 'Enter')) return

                    e.preventDefault()
                    onEnter()
                }}
            />
        </div>
        { err && <label className="field-status has-error">{err}</label> }
        </div>

        </div>
    </React.Fragment>
}
